import styled, { keyframes } from "styled-components";
import Icon from "../../assets/Icon";

interface IContainerProps {
    color: keyof ISystemColors;
    size: "small"|"medium"|"large";
    disabled?: boolean,
    loading?: boolean,
}

interface IIconProps {
    loading?: boolean,
}

export const Container = styled.button<IContainerProps>`
    width: fit-content;
    padding: 0 15px;
    height: ${props => props.size === "small" ? "25px" : props.size === "medium" ? "35px" : "50px"};
    border-radius: 25px;
    border: none;
    background-color: ${props => props.theme.colors[props.color]};
    color: ${props => props.theme.textColor[props.color]};
    font-size: ${props => props.size === "small" ? "12px" : props.size === "medium" ? "16px" : "24px"};
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    display: flex;
    align-items: center;
    opacity: ${props => props.disabled ? 0.85 : 1};
`;

export const PrependIcon = styled(Icon)<IIconProps>`
    margin-right: 5px;
    animation: ${props => props.loading ? SpinAnimation : ''};
    animation-duration: 1s;
    animation-iteration-count: infinite;
`;

export const AppendIcon = styled(Icon)<IIconProps>`
    margin-left: 5px;
    animation: ${props => props.loading ? SpinAnimation : ''};
    animation-duration: 1s;
    animation-iteration-count: infinite;
`;

export const SpinAnimation = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;